import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { INJECT_KEY } from "./defaults.js";

var Fennec = /*#__PURE__*/function () {
  function Fennec() {
    _classCallCheck(this, Fennec);

    this.ctx = void 0;
    this.connected = false;
  }

  _createClass(Fennec, [{
    key: "getExt",
    value: function getExt() {
      var _window, _window$__MIXIN__;

      return (_window = window) === null || _window === void 0 ? void 0 : (_window$__MIXIN__ = _window.__MIXIN__) === null || _window$__MIXIN__ === void 0 ? void 0 : _window$__MIXIN__[INJECT_KEY];
    }
  }, {
    key: "isAvailable",
    value: function isAvailable() {
      return Boolean(this.getExt());
    }
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(origin) {
        var _this$getExt;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.getExt()) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Browser Extension is not installed");

              case 2:
                _context.next = 4;
                return (_this$getExt = this.getExt()) === null || _this$getExt === void 0 ? void 0 : _this$getExt.enable(origin);

              case 4:
                this.ctx = _context.sent;
                this.connected = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect(_x) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.ctx = undefined;
      this.connected = false;
    }
  }]);

  return Fennec;
}();

export { Fennec as default };